// Called by : src/components/lesson/AssignmentsList.vue (train-item)

<template>
  <vsa-item :force-active="train.open" :on-heading-click="onHeadingClick">

    {{ forceUpdate }}
    
    <!-- btn btn-outline-light  -->
    <vsa-heading v-bind:data-class="trainClass">

      <div class="vsa_span vsa_train vsa_right d-none d-md-inline" v-bind:style="visioStyle">
        <span class="va_bottom">
          <a class="ui_tip text-white border-0 px-1 mr-3" v-bind:href="visioUrl" v-bind:class="visioClass" v-bind:title="visioTip" target="_blank" @click.stop="" style=""> <!-- font-size:1.5rem; -->
            <span class="oi oi-video"></span>
          </a>
        </span>
        <span class="va_bottom ui_tip px-1 mr-3" v-bind:title="typeLabel">
          <span class="oi " :class="typeIcon" style="font-size:1.5rem !important"></span>
        </span>
        <span class="va_bottom ui_tip px-1 mr-3" v-bind:title="modeLabel">
          <span class="oi " :class="modeIcon" style="margin-bottom: -0.25rem !important"></span>
        </span>
      </div>

      <span class="vsa_title_cont">
        <span class="vsa_span vsa_label vsa_label_train d-none d-md-inline">{{ trainName }}</span>
        <span class="vsa_span vsa_title vsa_title_train">{{ train.title }}</span>
      </span>

      <div class="vsa_span vsa_train mt-2 d-block d-md-none" v-bind:style="visioStyle">
        <span class="va_bottom">
          <a class="ui_tip text-white border-0 px-1 mr-3" v-bind:href="visioUrl" v-bind:class="visioClass" v-bind:title="visioTip" target="_blank" @click.stop="" style=""> <!-- font-size:1.5rem; -->
            <span class="oi oi-video"></span>
          </a>
        </span>
        <span class="va_bottom ui_tip px-1 mr-3" v-bind:title="typeLabel">
          <span class="oi " :class="typeIcon" style="font-size:1.25rem !important"></span>
        </span>
        <span class="va_bottom ui_tip px-1 mr-3" v-bind:title="modeLabel">
          <span class="oi " :class="modeIcon" style="margin-bottom: -0.25rem !important"></span>
        </span>
      </div>

    </vsa-heading>

    <vsa-content>
      <vsa-list :auto-collapse="false" :key="componentKey">
        <course-item v-for="course in train.courses" :key="course.id" :course="course" />
      </vsa-list>
    </vsa-content>

  </vsa-item>
</template>


<script>

// https://tkhquang.github.io/vue-simple-accordion/#recursive
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon
} from 'vue-simple-accordion'
import 'vue-simple-accordion/dist/vue-simple-accordion.css'

import CourseItem from '@/components/lesson/CourseItem'

export default {
  name: 'train-item',
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    CourseItem,
  },
  props: {
    train: Object
  },
  data() {
    return {
      componentKey: 0,
      trainName: this.$t("assignments.trainName"), // "assignments.trainName"
      trainClass: 'vsa_train',
      isSeq: 0,
      modeLabel: this.$t('assignments.modeFree'),
      modeIcon: 'oi-random',
      isShow: 0,
      typeLabel: this.$t('assignments.typeShow'),
      typeIcon: 'oi-tablet',
      visioUrl: '',
      visioTip: this.$t("assignments.tipVisioShow"),
      visioClass: '',
      visioStyle: '',
    }
  },
  methods: {
    onHeadingClick() {
      this.train.open = !this.train.open
    },
    getTrainMode(nMode = 0) {
      if (nMode < 0) nMode = 0;
      if (nMode > 1) nMode = 1;
      let listLabels = [this.$t('assignments.modeFree'), this.$t('assignments.modeSeq')];
      let listIcons = ['oi-random', 'oi-list'];
      this.modeLabel = listLabels[nMode];
      this.modeIcon = listIcons[nMode];
    },
    getUsingType(nType = 0) {
      let labelsList = [this.$t('assignments.typePerso'), this.$t('assignments.typeShow')];
      let iconsList = ['oi-tablet', 'oi-browser']; // monitor
      this.typeLabel = labelsList[nType];
      this.typeIcon = iconsList[nType];
    },
  },
  computed: {
    forceUpdate() {
      this.componentKey++

      this.trainName = this.$t("assignments.trainName"); // "assignments.trainName"
      $('.vsa_label_train').text(this.trainName);

      this.isSeq = 0 + Number(this.train.isSeq);
      this.getTrainMode(this.isSeq);

      this.isShow = 0 + Number(this.train.isShow);
      this.getUsingType(this.isShow);

      // console.log([this.isSeq,this.isShow]);

      this.visioUrl = this.train.visioUrl;
      this.visioTip = this.$t("assignments.tipVisioShow");
      this.visioClass = (this.visioUrl) ? '' : 'd-none';
      this.visioStyle = (this.visioUrl) ? 'margin-top:-0.25rem;' : '';

      return '';
    },
  }
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/lesson/TrainItem.vue